import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { X } from "lucide-react";
import CustomButton from "./Buttons";

// vehicle will not be deleted if its usage data is filled

const ConfirmationModal = ({
  isModalOpen,
  cancelText = "",
  confirmText = "",
  onConfirmClick = () => {},
  onCancelClick = () => {},
  text = "",
  header = "",
}) => {
  return (
    <div>
      <Dialog open={isModalOpen} onClose={onCancelClick}>
        <DialogTitle>
          {header}
          <button
            onClick={onCancelClick}
            className="absolute z-50 top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
        </DialogTitle>
        <DialogContent>{text}</DialogContent>
        <DialogActions>
          <div className="w-full flex justify-around px-4 mb-2 py-3">
            <CustomButton
              className="bg-gray-500 hover:bg-gray-600 text-white "
              click={onCancelClick}
              text={cancelText}
            />
            <CustomButton
              className="bg-red-500 hover:bg-red-700 text-white "
              click={onConfirmClick}
              text={confirmText}
            />
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmationModal;
